module.exports = __webpack_public_path__ + "img/closeRound.c11a1657.svg";